"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtrWrapper = void 0;
const interfaces_1 = require("@build-5/interfaces");
const AuctionOtrDataset_1 = require("./datasets/AuctionOtrDataset");
const AwardOtrDataset_1 = require("./datasets/AwardOtrDataset");
const MemberOtrDataset_1 = require("./datasets/MemberOtrDataset");
const NftOtrDataset_1 = require("./datasets/NftOtrDataset");
const ProposalOtrDataset_1 = require("./datasets/ProposalOtrDataset");
const SpaceOtrDataset_1 = require("./datasets/SpaceOtrDataset");
const StampOtrDataset_1 = require("./datasets/StampOtrDataset");
const SwapOtrDataset_1 = require("./datasets/SwapOtrDataset");
const TokenOtrDataset_1 = require("./datasets/TokenOtrDataset");
/**
 * OTR Dataset selection.
 *
 */
class OtrWrapper {
    constructor(otrAddress) {
        this.otrAddress = otrAddress;
    }
    /**
     * Access Dataset.
     *
     * @param dataset {@link DatasetType}
     * @returns
     */
    dataset(dataset) {
        switch (dataset) {
            case interfaces_1.Dataset.AUCTION:
                return new AuctionOtrDataset_1.AuctionOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.AWARD:
                return new AwardOtrDataset_1.AwardOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.MEMBER:
                return new MemberOtrDataset_1.MemberOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.NFT:
                return new NftOtrDataset_1.NftOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.PROPOSAL:
                return new ProposalOtrDataset_1.ProposalOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.SPACE:
                return new SpaceOtrDataset_1.SpaceOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.TOKEN:
                return new TokenOtrDataset_1.TokenOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.STAMP:
                return new StampOtrDataset_1.StamptOtrDataset(this.otrAddress);
            case interfaces_1.Dataset.SWAP:
                return new SwapOtrDataset_1.SwapOtrDataset(this.otrAddress);
            default:
                throw Error('invalid dataset name');
        }
    }
}
exports.OtrWrapper = OtrWrapper;
